import React, { useContext, useState } from 'react';
import styled from 'styled-components';

import Wrapper from '../elements/wrapper';
import { media } from '../helpers';

import { StoreContext } from '../../context/StoreContext';

import X from '../../images/icons/x.inline.svg';

const CollectionBreadCrumbContainer = styled.div`
    .collection-breadcrumb {
        ${media.medium`max-width: 80vw; display: flex;`}

        .breadcrumb-title {
            margin-bottom: 35px;
            flex: 1;
            h2 {
                color: #000;
                margin: 0 0 15px;
                font-size: 1.2rem;
                font-weight: bold;
                sup {
                    top: -0.8em;
                    font-weight: normal;
                    font-size: 0.8rem;
                    left: -2px;
                }
            }

            p {
                margin: 0;
                color: #0f1212;
                ${media.medium`max-width: 40vw;`}
            }
        }

        .breadcrumb-active-filters {
            display: none;
            ${media.medium`display: block;`}
        }
    }
`;

const CollectionBreadCrumb = ({
    collectionCaption,
    collection,
    collectionCount,
    setActiveFilters,
    activeFilters,
    isMobileFilterActive,
    setIsMobileFilterActive,
}) => {
    return (
        <CollectionBreadCrumbContainer>
            <Wrapper className="collection-breadcrumb">
                <div className="breadcrumb-title">
                    <h2>
                        Shop {'>'} Apparel {'>'} {collection.title}{' '}
                        <sup>{collectionCount}</sup>
                    </h2>
                    {collectionCaption && <p>{collectionCaption}</p>}
                </div>
                <ActiveFilters
                    activeFilters={activeFilters}
                    setActiveFilters={setActiveFilters}
                    isMobileFilterActive={isMobileFilterActive}
                    setIsMobileFilterActive={setIsMobileFilterActive}
                />
            </Wrapper>
        </CollectionBreadCrumbContainer>
    );
};

const ActiveFiltersStyles = styled.div`
    .breadcrumb-active-filters {
        ul {
            margin: 0;
            padding: 0;
            list-style: none;
            li {
                display: inline-block;
                margin-right: 15px;
                margin-bottom: 10px;
                ${media.medium`margin-bottom: 0px;`}
                button {
                    background-color: #f2f0eb;
                    border: 1px solid #f2f0eb;
                    padding: 7px 10px;
                    display: flex;
                    font-size: 0.9rem;
                    text-transform: capitalize;

                    &.clear {
                        background-color: #000;
                        color: #fff;
                    }

                    svg {
                        height: 17px;
                        width: 17px;
                        position: relative;
                        top: 3px;
                        margin-left: 5px;
                    }
                }
            }
        }
    }
`;

const ActiveFilters = ({
    setActiveFilters,
    activeFilters,
    setIsMobileFilterActive,
    isMobileFilterActive,
}) => {
    const { pattern, style, kids_options, recycled_options } =
        activeFilters || {};
    const { colorHandlize } = useContext(StoreContext);

    function handleFilterRemoval(filter) {
        filter.name = filter.name
            .replace('recycled-options', 'recycled_options')
            .replace('kids-options', 'kids_options');

        // make a new array without the removed tag
        let updatedArray = activeFilters[filter.name].filter(
            (array) => array.value !== filter.value
        );

        setActiveFilters({
            ...activeFilters,
            [filter.name]: updatedArray,
        });
    }

    function clearAllFilters() {
        setActiveFilters({
            pattern: [],
            recycled_options: [],
            kids_options: [],
            style: [],
        });
    }

    return (
        <ActiveFiltersStyles>
            <div className="breadcrumb-active-filters">
                <ul>
                    {((pattern && pattern.length > 0) ||
                        (style && style.length > 0) ||
                        (kids_options && kids_options.length > 0) ||
                        (recycled_options && recycled_options.length > 0)) && (
                        <li>
                            <button
                                className="clear"
                                onClick={() => clearAllFilters()}
                            >
                                Clear Filters{' '}
                                <span>
                                    <X />
                                </span>{' '}
                            </button>
                        </li>
                    )}
                    {pattern &&
                        pattern.length > 0 &&
                        pattern.map((singlePattern) => {
                            return (
                                <li>
                                    <button
                                        onClick={() =>
                                            handleFilterRemoval(singlePattern)
                                        }
                                    >
                                        {singlePattern.value.replace(
                                            'pattern_',
                                            ''
                                        )}
                                        <span>
                                            <X />
                                        </span>
                                    </button>
                                </li>
                            );
                        })}
                    {style &&
                        style !== null &&
                        style.map((singleStyle) => {
                            return (
                                <li>
                                    <button
                                        onClick={() =>
                                            handleFilterRemoval(singleStyle)
                                        }
                                    >
                                        {colorHandlize(
                                            singleStyle.value
                                        ).replace('style_', '')}
                                        <span>
                                            <X />
                                        </span>
                                    </button>
                                </li>
                            );
                        })}
                    {kids_options &&
                        kids_options.length > 0 &&
                        kids_options.map((singleKidsOption) => {
                            return (
                                <li>
                                    <button
                                        onClick={() =>
                                            handleFilterRemoval(
                                                singleKidsOption
                                            )
                                        }
                                    >
                                        {colorHandlize(singleKidsOption.value)
                                            .replace('style_', '')
                                            .replace(
                                                'kids_options',
                                                'Kids Options'
                                            )}
                                        <span>
                                            <X />
                                        </span>
                                    </button>
                                </li>
                            );
                        })}
                    {recycled_options &&
                        recycled_options.length > 0 &&
                        recycled_options.map((singleRecycledOption) => {
                            return (
                                <li>
                                    <button
                                        onClick={() =>
                                            handleFilterRemoval(
                                                singleRecycledOption
                                            )
                                        }
                                    >
                                        {colorHandlize(
                                            singleRecycledOption.value
                                        )
                                            .replace('style_', '')
                                            .replace(
                                                'recycled_options',
                                                'Recycled Options'
                                            )}
                                        <span>
                                            <X />
                                        </span>
                                    </button>
                                </li>
                            );
                        })}
                </ul>
            </div>
        </ActiveFiltersStyles>
    );
};

export { ActiveFilters };

export default CollectionBreadCrumb;
